var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "tab-scroll-container w-full flex flex-row align-center" },
    [
      _c("el-button", {
        staticClass: "scroll-btn left-btn",
        attrs: { icon: "el-icon-arrow-left", size: "mini" },
        on: {
          click: function ($event) {
            return _vm.handleScroll(-1)
          },
        },
      }),
      _c(
        "div",
        {
          ref: "scrollWrap",
          staticClass: "scroll-wrap",
          class: { "is-dragging": _vm.isDragging },
          on: {
            scroll: _vm.handleWrapScroll,
            mousedown: _vm.startDragging,
            mouseleave: _vm.stopDragging,
            mouseup: _vm.stopDragging,
          },
        },
        [_c("div", { staticClass: "tab-list" }, [_vm._t("default")], 2)]
      ),
      _c("el-button", {
        staticClass: "scroll-btn right-btn",
        attrs: { icon: "el-icon-arrow-right", circle: "", size: "mini" },
        on: {
          click: function ($event) {
            return _vm.handleScroll(1)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }